module.exports = __webpack_public_path__ + "static/img/platform_for_success_1.79d101d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/platform_for_success_1.png
// module id = 1780
// module chunks = 5